import { useNuxtApp, useState, useToast, useUser } from "#imports";
import { isDevelopment } from "~/constants";

interface MetricCustomProperties {
  map_name?: string | null;
  map_id?: string | null;
  creator_handle?: string | null;
  creator_id?: string | null;
  spot_id?: string | null;
  spot_name?: string;
  spot_destination?: string;
  spot_category?: string;
  countries?: string[];
  friction?: string;
  attribution_last_click?: string;
  product?: string;
  product_price?: string;
  product_id?: string;
  product_period?: string;
  payment_amount?: number;
  payment_currency?: string;
  subscription_tier?: string;
}

export const useMetrics = () => {
  const userStore = useUser();
  const { logger } = useToast();
  const { $posthogClient } = useNuxtApp();

  const lastSeenCreator = useState<string | null>(
    "lastSeenCreator",
    () => null,
  );

  const trackEvent = (event: string, properties?: MetricCustomProperties) => {
    if (properties?.creator_handle) {
      lastSeenCreator.value = properties.creator_handle;
    }
    const propsSchema = {
      is_authenticated: userStore.user.id !== null,
      ...properties,
      ...(lastSeenCreator.value && {
        attribution_last_click: lastSeenCreator.value,
      }),
    };

    if (isDevelopment) {
      console.log(
        "⏩ Events Disabled in Development mode event details: ",
        event,
      );
      return;
    }
    try {
      $posthogClient.capture(event, propsSchema);
    } catch (e) {
      /*
       * if the events server is down we just drop the events to prevent excessive errors
       */
      logger("failed to track user event", e);
    }
  };

  return {
    trackEvent,
  };
};
